function CartPage({ cart, onRemove }) {
  const total = cart.reduce((s, i) => s + i.price * i.qty, 0);
  return (
    <div className="page">
      <p className="section-titl">YOUR BAG</p>
      <h1 className="bigTitle">CART</h1>
      {cart.length === 0 ? (
        <div
          style={{
            padding: "80px 0",
            textAlign: "center",
            color: "#222",
            fontSize: 12,
            letterSpacing: "0.25em",
            fontFamily: "monospace",
          }}
        >
          CART IS EMPTY
        </div>
      ) : (
        <div style={{ maxWidth: 680 }}>
          {cart.map((item) => {
            const imgs = item.images;
            return (
              <div key={item.id} className="cart-item">
                <div style={{ display: "flex", gap: 18, alignItems: "center" }}>
                  <img
                    src={imgs[0]}
                    alt={item.name}
                    style={{ width: 68, height: 88, objectFit: "cover" }}
                  />
                  <div>
                    <p
                      style={{
                        margin: "0 0 4px",
                        fontSize: 12,
                        letterSpacing: "0.12em",
                        fontWeight: 700,
                      }}
                    >
                      {item.name}
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: 11,
                        color: "#444",
                        fontFamily: "monospace",
                      }}
                    >
                      QTY: {item.qty}
                    </p>
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <p
                    style={{
                      margin: "0 0 7px",
                      fontFamily: "monospace",
                      fontSize: 13,
                    }}
                  >
                    ₹{(item.price * item.qty).toLocaleString("en-IN")}
                  </p>
                  <button
                    className="remove-btn"
                    onClick={() => onRemove(item.id)}
                  >
                    REMOVE
                  </button>
                </div>
              </div>
            );
          })}
          <div
            style={{
              padding: "28px 0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderTop: "1px solid #1a1a1a",
              marginTop: 14,
            }}
          >
            <div>
              <p
                style={{
                  margin: "0 0 4px",
                  fontSize: 9,
                  letterSpacing: "0.25em",
                  color: "#777",
                }}
              >
                ORDER TOTAL
              </p>
              <p style={{ margin: 0, fontSize: 32, fontWeight: 800 }}>
                ₹{total.toLocaleString("en-IN")}
              </p>
            </div>
            <p
              style={{
                fontSize: 10,
                color: "#333",
                letterSpacing: "0.15em",
                fontFamily: "monospace",
                textAlign: "right",
              }}
            >
              CHECKOUT COMING SOON
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default CartPage;
